import {createSlice} from "@reduxjs/toolkit";

const initialManageAreasState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  ManageAreasForEdit: undefined,
  lastError: null,
  council:[]
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const ManageAreasSlice = createSlice({
  name: "ManageAreas",
  initialState: initialManageAreasState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCustomerById
    areaFetched: (state, action) => {
      state.actionsLoading = false;
      state.ManageAreasForEdit = action.payload.ManageAreasForEdit;
      state.error = null;
    },

    // getCouncil
    CouncilFetched: (state, action) => {
      const { data } = action.payload;
      state.council = data;
    
    },
    // findTowns
    ManageAreasFetched: (state, action) => {
      // const { totalCount, entities } = action.payload;
      const { length, data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = data;
      state.totalCount = length;
     
    },
    // createArea
    AreaCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.data);
      // state.entities.push(action.payload.ManageArea);
    },
    // updateCustomer
    AreaUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.ManageAreas.id) {
          return action.payload.ManageAreas;
        }
        
        return entity;
      });
    },
    // deleteCustomer
    AreaDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteCustomers
    customersDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // customersUpdateState
    customersStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
